import { PropTypes } from "prop-types";
import { SmallAvatar } from "../../styles/materialUi/avatar";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import "./profileSubSection.scss";

const propTypes = {
  index: PropTypes.number.isRequired,
  alt: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  detailTitle: PropTypes.string.isRequired,
  detailSubTitle: PropTypes.string.isRequired,
  startsAt: PropTypes.objectOf(PropTypes.any).isRequired,
  endsAt: PropTypes.objectOf(PropTypes.any),
  description: PropTypes.string,
};

const defaultProps = {
  endsAt: "",
  description: "",
};

const months = [
  "Jan.",
  "Feb.",
  "Mar.",
  "Apr.",
  "May.",
  "Jun.",
  "Jul.",
  "Aug.",
  "Sep.",
  "Oct.",
  "Nov.",
  "Dec.",
];

const ProfileSubSection = ({
  index,
  alt,
  logoUrl,
  detailTitle,
  detailSubTitle,
  startsAt,
  endsAt,
  description,
}) => {
  const getMonth = (monthNum) => {
    if (monthNum) {
      return `${months[monthNum - 1]} `;
    }
    return "";
  };

  return (
    <div className="profile-subsection">
      <ProfilePicture
        profileId={`${index}`}
        avatar={SmallAvatar}
        editable={false}
        alt={alt}
        linkedInPicUrl={logoUrl}
        variant="square"
      />
      <div className="detail">
        <h5>{detailTitle}</h5>
        <h6>{detailSubTitle}</h6>
        <p className="dates">{`${getMonth(startsAt.month)}${startsAt.year} - ${
          endsAt?.year
            ? `
          ${getMonth(endsAt.month)}
        ${endsAt.year}`
            : "Present"
        }`}</p>
        <p className="description">{description}</p>
      </div>
    </div>
  );
};

ProfileSubSection.propTypes = propTypes;
ProfileSubSection.defaultProps = defaultProps;

export default ProfileSubSection;
